<div class="innerpage-fullwithbanner dashboardarea clearfix">
  <div class="left">
    <h2 class="bighead" *ngIf="IsmyPortfolio">My Portfolio</h2>
    <h2 class="bighead" *ngIf="!IsmyPortfolio">{{selectedPortfolioName}}'s Portfolio</h2>
    <ul class="bread-crumbs">
      <li *ngIf="this.authentication.Admin()||this.authentication.SuperAdmin()"><a (click)="Validation.redirect('/')">Home<span>|</span></a></li>
      <li *ngIf="this.authentication.Principal() || this.authentication.Seller() || this.authentication.Principal1031()"><a (click)="onHomeBreadCrumbClick();">Home<span>|</span></a></li>
      <li *ngIf="this.authentication.Admin()||this.authentication.SuperAdmin()">
        <a (click)="onBreadCrumbClick(0);" *ngIf="IsFrom!=1">User Portfolios<span>|</span></a>
        <a (click)="onBreadCrumbClick(1);" *ngIf="IsFrom==1">External Users<span>|</span></a>
      </li>
      <li *ngIf="IsmyPortfolio">My Portfolio</li>
      <li *ngIf="!IsmyPortfolio">{{selectedPortfolioName}}'s Portfolio</li>
    </ul>
  </div>
  <div class="right" *ngIf="!authentication.Admin()&&!authentication.SuperAdmin()&&hasAccess==1&&UserPortfolio?.length>1">
     <label class="select breadcumbarea-select bigselect">
      <select class="form-control myPortfolioNormalHeading" id="exchangeSelect" [(ngModel)]="selectedPortfolio" (change)="bindData();">
        <option *ngFor="let item of UserPortfolio" [(ngValue)]="item.Id">{{item.Name=='My Portfolio' ?'My Portfolio':item.Name}}{{item.Name=='My Portfolio'?'':portfolioData}}</option>
      </select>
      <i></i>
    </label>
  </div>
  <div class="clearfix"></div>
</div>
<div class="dashboardstyles section-margin be-dashboard-wrap seller-dashboard-wrap">
  <ul class="switchingproperty" style="margin:-20px 0 10px 0" *ngIf="hasAccess==1">
    <li [class.active]="currentTab == tabs.MarketSnapShot" (click)="onTabClick(tabs.MarketSnapShot)">
      <a href="javascript:void(0);">
        Market Snapshot
      </a>
    </li>
    <li [class.active]="currentTab == tabs.PortfolioAnalysis" (click)="onTabClick(tabs.PortfolioAnalysis)">
      <a href="javascript:void(0);">
        My Properties
      </a>
    </li>
    <li [class.active]="currentTab == tabs.Files" (click)="onTabClick(tabs.Files)">
      <a href="javascript:void(0);">
        Files
      </a>
    </li>
    <li [class.active]="currentTab == tabs.MasterContactList" (click)="onTabClick(tabs.MasterContactList)">
      <a href="javascript:void(0);">
        My Contacts
      </a>
    </li>
    <li [class.active]="currentTab == tabs.AssetManagement" (click)="onTabClick(tabs.AssetManagement)">
      <a href="javascript:void(0);">
        Asset Management
      </a>
    </li>
    <li [class.active]="currentTab == tabs.Preferences" (click)="onTabClick(tabs.Preferences)" *ngIf="(IsmyPortfolio||authentication.Admin()||authentication.SuperAdmin())">
      <a href="javascript:void(0);">
        Access Controls
      </a>
    </li>

  </ul>
  <div class=" container container-1140 min-heightcontainer market-snapshot-wrapper " *ngIf="currentTab == tabs.MarketSnapShot&&hasAccess==1">
    <ng-container>
      <div class="row">
        <div class="floatinghead clearfix">
        </div>
      </div>
      <div class="clearfix"></div>
      <ng-container *ngIf="hasAccess">
        <div class="col-lg-4 margin-bottom-20 margin-top-20">
          <h3 class="bluelabel margin-bottom-0 margin-top-10">Market Snapshot</h3>
        </div>
        <div class="margin-bottom-40">
          <app-market-snapshot-chart [UserGuid]="principalUserGuid" [PortfolioName]="selectedPortfolioName"></app-market-snapshot-chart>
          <app-my-portfolio-properties [UserGuid]="principalUserGuid" [PortfolioName]="selectedPortfolioName"></app-my-portfolio-properties>
          <app-watch-list [UserGuid]="principalUserGuid" [IsmyPortfolio]="IsmyPortfolio" [PortfolioName]="selectedPortfolioName"></app-watch-list>
          <app-pending-portfolio-properties [UserGuid]="principalUserGuid" [IsmyPortfolio]="IsmyPortfolio" [PortfolioName]="selectedPortfolioName"></app-pending-portfolio-properties>
        </div>
      </ng-container>
    </ng-container>
    <div class="clearfix"></div>
  </div>
    <div class="tabstyle2 dashboardtab" style="background:#fff;" *ngIf="hasAccess==2">
      <div class="successstep container min-heightcontainer margin-bottom-0">
        <img src="/assets/img/settings.png" class="centerimg" />
        <!--<h4>Hi {{sellerName}}, We are setting up your seller dashboard.</h4>-->
        <h4>My Portfolio is in development. Stay tuned for release dates!</h4>
        <h6>Contact <a href="mailto:info@tradenetlease.com" class="my-portfolio-noaccess-content">info&#64;tradenetlease.com</a> to learn more and inquire about beta testing.</h6>
        <h6 class="margin-top-15"><a href="https://info.tradenetlease.com/subscribe" target="_blank" class="my-portfolio-noaccess-content">Subscribe</a> to stay up to date about our next release date.</h6>
      </div>
    </div>

  <div *ngIf="currentTab == tabs.PortfolioAnalysis&&hasAccess==1">
    <ng-container>
      <div class="row">
        <div class="floatinghead clearfix">
        </div>
      </div>
      <div class="clearfix"></div>
      <ng-container>
        <div>
          <app-property-listing [UserGuid]="principalUserGuid"></app-property-listing>
        </div>
      </ng-container>
    </ng-container>
    <div class="clearfix"></div>

  </div>
  <div class="container min-heightcontainer" *ngIf="currentTab == tabs.Files&&hasAccess==1">
    <div class="border-div">
      <ng-container>
        <div class="row">
          <div class="floatinghead clearfix">
          </div>
        </div>
        <div class="clearfix"></div>
        <ng-container>
          <div>
            <app-portfolio-files [source]="'MyPortfolio'" [UserGuid]="principalUserGuid"></app-portfolio-files>
          </div>
        </ng-container>
      </ng-container>
    </div>
    <div class="clearfix"></div>
  </div>
  <div class="container min-heightcontainer" *ngIf="currentTab == tabs.MasterContactList&&hasAccess==1">
    <div class="border-div">
      <ng-container>
        <div class="row">
          <div class="floatinghead clearfix">
          </div>
        </div>
        <div class="clearfix"></div>
        <ng-container>
          <div>
            <app-master-contact [UserGuid]="principalUserGuid"></app-master-contact>
          </div>
        </ng-container>
      </ng-container>
      <div class="clearfix"></div>
    </div>
  </div>
  <div class="container min-heightcontainer" *ngIf="currentTab == tabs.AssetManagement&&hasAccess==1">
    <div class="border-div">
      <ng-container>
        <div class="row">
          <div class="floatinghead clearfix">
          </div>
        </div>
        <div class="clearfix"></div>
        <ng-container>
          <h3 class="bluelabel margin-bottom-0 margin-top-10">Asset Management</h3>
          <h2 class="subhead margin-top-20">
            <span class="text">
              Under Construction: Coming soon in 2023. Stay tuned for release announcements. Join the waitlist to be the first to learn about release information
            </span>
          </h2>
        </ng-container>
      </ng-container>
      <div class="clearfix"></div>
    </div>
  </div>
  <div class="container min-heightcontainer" *ngIf="(IsmyPortfolio||authentication.Admin()||authentication.SuperAdmin())&&currentTab == tabs.Preferences&&hasAccess==1">
    <div class="border-div">
      <ng-container>
        <div class="row">
          <div class="floatinghead clearfix">
          </div>
        </div>
        <div class="clearfix"></div>
        <ng-container>
          <div>
            <app-preference [UserGuid]="principalUserGuid"></app-preference>
          </div>
        </ng-container>
      </ng-container>
      <div class="clearfix"></div>
    </div>
  </div>
</div>
